import React from 'react';
import axios from 'axios';
import { Table, Space, Button, Popconfirm, Tooltip, notification } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import FormM from './Form';
import Spinner from '../../components/spinner';
import * as filter from '../../global/FilterFun';
import AdminHeader from '../../components/adminHeader';

class trackList extends React.Component{
    state = { tracks: [], searchText: '',
    searchedColumn: '', visible: false, rowToEdit: [], loading: true,
    showNew: false}

    componentDidMount(){
      this.setState({loading: true})
      axios.defaults.headers = {
          "Content-Type": "application/json",
          Authorization: "Token "+localStorage.getItem('token')
      }
      axios.get('/api/track/').then(
          res => {
              this.setState({tracks: res.data, loading: false})
          }
      )
    }

    getColumnSearchProps = dataIndex => filter.getColumnSearchProps(dataIndex) 
    
    showModal = id => {
      this.setState({loading: true});
      axios.get(`/api/track/${id}/`).then(
          res => {
              this.setState({rowToEdit: res.data, visible: true, loading: false})
          }
      );
    };

    delete = id => {
      this.setState({loading: true});
      axios.delete(`/api/track/${id}/`).then(
          res => {
            notification["success"]({
              message: 'Registro eliminado exitosamente',
            });
            this.setState({loading: false});
            this.componentDidMount();
          }
      );
    };
  
    showNew = b => {
      this.setState({
        showNew: b,
      });
    };

    regSaved = s =>{
      this.showNew(false)
      if(s === true){
        this.componentDidMount()
      }
    }
  
    handleCancel = e => {
      this.setState({
        visible: false,
      });
      if(e === true){
        this.componentDidMount()
      }
    };

    cancel = e =>{}

    render(){
        const columns = [
            {
              title: 'Nombre',
              dataIndex: 'name',
              ...this.getColumnSearchProps('name'),
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortDirections: ['ascend', 'descend'],
            },
            {
                title: 'Acciones',
                key: 'action',
                width: '20%',
                render: (text, record) => (
                <Space size="middle">
                  <Tooltip title="Editar">
                    <Button type="primary" onClick={() => this.showModal(record.id)}>
                      <EditOutlined />
                    </Button>
                  </Tooltip>
                  <Popconfirm title="Eliminará un registro, ¿continuar?"
                    onConfirm={() => this.delete(record.id)}
                    onCancel={this.cancel}
                    okText="Si"
                    cancelText="No"
                  >
                    <Tooltip title="Eliminar">
                      <Button type="primary" danger>
                        <DeleteOutlined />
                      </Button>
                    </Tooltip>
                  </Popconfirm>
                </Space>
                ),
            },
          ];
        return(
            <div>
                { localStorage.getItem('token') == null ? this.props.history.push('/login') : ''}
                <AdminHeader title="Pistas" showNew={this.showNew} />
                <Spinner spinning={this.state.loading}>
                  <Table columns={columns} dataSource={this.state.tracks} />
                  
                  <FormM visible={this.state.visible} onCancel={this.handleCancel}
                    data={this.state.rowToEdit} />

                  <FormM visible={this.state.showNew} onCancel={this.regSaved} />
                </Spinner>
            </div>
        );
    }
}

export default trackList;